module.exports = __webpack_public_path__ + "static/bgMobile-min-7277d019e2dfaedb72e30ed4c108c139.jpg";